/* eslint-disable import/no-unused-modules */
import { cn } from '@rocco/index';
import { PROPOSAL_TYPO_CLASS } from './proposal-styles';

interface ProductNameComponentProps {
    name: string;
    description?: string;
}

/** Displays product name and description in the proposal product table. */
export const ProductNameComponent = ({
    name,
    description,
}: ProductNameComponentProps) => (
    <div className="flex flex-col pl-[0.5rem] md:pl-[0.5rem]">
        <span
            className={cn(
                PROPOSAL_TYPO_CLASS.PRODUCT_TABLE_ROW_TITLE,
                'mt-[0.87rem]',
            )}
        >
            {name}
        </span>
        <span
            className={cn(
                PROPOSAL_TYPO_CLASS.PRODUCT_TABLE_ROW_DESC,
                'mb-[0.4rem] max-w-[19.13rem] whitespace-pre-line leading-[1.175] md:leading-[1.225] md:tracking-[0.01rem]',
            )}
        >
            {description}
        </span>
    </div>
);

export default ProductNameComponent;
